module.exports = __webpack_public_path__ + "img/profile.3177d114.svg";